<template>
  <div class="relative">
    <h1
      class="flex flex-col items-center space-y-16 text-center font-medium md:space-y-20 lg:space-y-24 xl:space-y-28"
    >
      <span
        class="type-font-salt-ss02 text-[30px]/[1.1em] font-medium md:text-[50px]/[1.1em] xl:text-[60px]/[1.1em]"
        >wait! for more</span
      >
      <span class="large-text type-font-salt-ss02 text-charcoal -rotate-2"
        ><span>family time</span></span
      >
    </h1>
    <div class="icons pointer-events-none absolute inset-0">
      <PayloadIcon
        class="absolute bottom-0 left-[0.5em] h-[0.3em] -rotate-16 text-white"
        icon="SvgIconCloud"
      />
      <PayloadIcon
        class="text-red-light absolute bottom-[0.65em] left-[1.45em] h-[0.3em]"
        icon="SvgIconHeart"
      />
      <PayloadIcon
        class="text-yellow absolute bottom-[0.7em] left-[3.8em] h-[0.3em]"
        icon="SvgIconFlowerPetals"
      />
      <PayloadIcon
        class="text-blue-dark absolute bottom-[-0.3em] left-[2.8em] h-[0.3em] -rotate-16"
        icon="SvgIconWave"
      />
    </div>
  </div>
</template>

<style scoped>
@reference '#css';

span {
  @apply inline-block;
}
</style>
